import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';

export default function CompanyGridEnabled({ companyGrid, onChange }) {
  return (
    <Card>
      <Card.Body>
        <ManagedInput
          checked={companyGrid.enabled}
          name="enabled"
          type="checkbox"
          onChange={onChange}
        >
          Enable grid template
        </ManagedInput>

        <div className="mt-2">
          When enabled, company users with Grids turned on will be able to select this grid template
          from a listing’s Grids tab.
        </div>
      </Card.Body>
    </Card>
  );
}

CompanyGridEnabled.propTypes = {
  companyGrid: PropTypes.shape({
    enabled: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func,
};
